<template>
    <div id="InformacoesAdicionais" v-if="checarVizualisacao()">

    <div class="card">
        <div class="card-content" id="client-card">
            <div class="card-personal card-user">
                 <button id="edit-mode"
                        @click="clienteEditar(pedido.cliente_has_produto.cliente.cliente_id)"
                        class="edit secondary-content icon-action btn-floating btn-flat btn-transparent"
                        v-tooltip.bottom="'Editar dados do Cliente'">
                        <i class="material-icons grey-text">mode_edit</i>
                    </button>
                <div style="position:relative" id="card-profile">

                    <div id="card-profile-image-action" class="card-profile-image-action"
                        @click="showModalAvatar()">
                        <i
                            @click="showModalAvatar()"
                            style="font-size: 50px; text-align: center"
                            class="responsive-img activator white-text material-icons"
                        >
                            photo
                        </i>

                        <span class="white-text">Trocar</span>
                    </div>
                    <img
                        v-if="imgDataUrl"
                        :src="imgDataUrl"
                        class="circle responsive-img activator card-profile-image"
                        style="height: 150px;"

                    >
                    <div v-if="!imgDataUrl" class="white-text circle" style="background-color:#fafafa; display: flex; justify-content: center; align-items: center; height: 150px; width:150px; text-align: center">
                        <i
                            v-if="!imgDataUrl"
                            style="color: #cfcfcf; font-size: 80px; text-align: center"
                            class="card-profile-image responsive-img activator material-icons circle"
                        >
                        person
                    </i>

                    </div>

                </div>
                  <my-upload
                            field="img"
                            @crop-success="cropSuccess"
                            @crop-upload-success="cropUploadSuccess"
                            @crop-upload-fail="cropUploadFail"
                            v-model="show"
                            :width="300"
                            :height="300"
                            :url="url"
                            :params="params"
                            :headers="headers"
                            img-format="png"
                            lang-type="pt-br"
                        >
                        </my-upload>
                 <span class="card-title">{{ pedido.cliente_has_produto.cliente.pessoa.pessoa_nome }}</span>
                 <span class="card-subtitle">{{ pedido.cliente_has_produto.cliente.pessoa.pessoa_profissao ? pedido.cliente_has_produto.cliente.pessoa.pessoa_profissao : 'Não informado' }}</span>
                <div id="card-actions" class="card-actions" v-if="showButtons">
                    <button class="waves-effect waves-light blue darken-4 btn"
                        :class="disableField()"
                        @click="modalCold()"
                        v-if="showButtons">Analise de Necessidades</button>

                    <button class="waves-effect red darken-4 waves-light  btn"
                        :class="disableField()"
                        @click="modalLost()"
                        v-if="showButtons">Não Efetivado</button>
                </div>
                <div class="row" style="width: 100%">
                    <div class="card-list s12">
                        <ul class="collection">
                            <li class="info-big collection collection-item" style="border-bottom: 1px solid #e0e0e0 !important;" v-if="checaUsuario([cargoDono, cargoGerente, cargoEspecialista, cargoCorretor, cargoLider])">
                                <div>Consultor
                                    <div class="secondary-content card-subtitle">
                                        <a href="#!"
                                            style="text-transform: capitalize !important;"
                                            v-if="checaUsuario()"
                                            @click="abreModalTroca()">
                                            {{ pedido.pedido_historico.funcionario ? capitalize(pedido.pedido_historico.funcionario.pessoa.pessoa_nome) : '[SITE]' }}
                                        </a>
                                        <button id="autorenew"
                                            v-if="checaUsuario()"
                                            @click="abreModalTroca()"
                                            class="waves-effect waves-teal btn-flat no-padding"
                                            v-tooltip.bottom="'Trocar responsável'">
                                            <i class="material-icons">autorenew</i>
                                        </button>
                                    </div>
                                </div>
                            </li>
                            <li class="collection-item" v-if="myChecaCargoUsuario([cargoCorretor, cargoLider], [cargoCorretor, cargoLider])">
                                <div>Autor
                                    <div class="secondary-content card-subtitle">
                                         <p>
                                            <span v-if="myChecaCargoUsuario([cargoCorretor, cargoLider], [cargoCorretor, cargoLider])" style="text-transform: capitalize !important;">{{ pedido.funcionario ? capitalize(pedido.funcionario.pessoa.pessoa_nome) : '[SITE]' }}</span>
                                        </p>
                                    </div>
                                </div>
                            </li>
                             <li class="collection-item">
                                <div>Gênero
                                    <div class="secondary-content card-subtitle">
                                         <p>
                                            <span v-if="! pedido.cliente_has_produto.cliente.pessoa.pessoa_sexo">Não informado</span>
                                            <span v-if="pedido.cliente_has_produto.cliente.pessoa.pessoa_sexo === 'M'">Masculino</span>
                                            <span v-if="pedido.cliente_has_produto.cliente.pessoa.pessoa_sexo === 'F'">Feminino</span>
                                        </p>
                                    </div>
                                </div>
                            </li>
                            <li class="collection-item">
                                <div>Estado civil
                                    <div class="secondary-content card-subtitle">
                                         <p>
                                            <span v-if="! pedido.cliente_has_produto.cliente.pessoa.pessoa_estado_civil">Não informado</span>
                                            <span v-if="pedido.cliente_has_produto.cliente.pessoa.pessoa_estado_civil === 'C'">Casado</span>
                                            <span v-if="pedido.cliente_has_produto.cliente.pessoa.pessoa_estado_civil === 'S'">Solteiro</span>
                                            <span v-if="pedido.cliente_has_produto.cliente.pessoa.pessoa_estado_civil === 'D'">Divorciado</span>
                                            <span v-if="pedido.cliente_has_produto.cliente.pessoa.pessoa_estado_civil === 'V'">Viúvo</span>
                                        </p>
                                    </div>
                                </div>
                            </li>
                            <li class="collection-item">
                                <div>Profissão
                                    <div class="secondary-content card-subtitle">
                                         <p>
                                            {{ pedido.cliente_has_produto.cliente.pessoa.pessoa_profissao ? pedido.cliente_has_produto.cliente.pessoa.pessoa_profissao : 'Não informado' }}
                                        </p>
                                    </div>
                                </div>
                            </li>
                            <li class="collection-item">
                                <div>Celular
                                    <div class="secondary-content card-subtitle">
                                         <p>
                                            {{
                                                pedido.cliente_has_produto.cliente.pessoa.pessoa_celular ? pedido.cliente_has_produto.cliente.pessoa.pessoa_celular : 'Não informado'
                                                | phone
                                            }}
                                        </p>
                                    </div>
                                </div>
                            </li>
                            <li class="collection-item">
                                <div>Telefone
                                    <div class="secondary-content card-subtitle">
                                         <p>
                                            {{
                                                pedido.cliente_has_produto.cliente.pessoa.pessoa_telefone ? pedido.cliente_has_produto.cliente.pessoa.pessoa_telefone : 'Não informado'
                                                | phone
                                            }}
                                        </p>
                                    </div>
                                </div>
                            </li>
                            <li class="collection-item-custom">
                                <span>Email</span>
                                <p>
                                    {{ pedido.cliente_has_produto.cliente.pessoa.pessoa_email }}
                                </p>
                            </li>
                            <li class="collection-item">
                                <div>CPF
                                    <div class="secondary-content card-subtitle">
                                         <p>
                                            {{
                                                pedido.cliente_has_produto.cliente.pessoa.pessoa_cpf ? pedido.cliente_has_produto.cliente.pessoa.pessoa_cpf : 'Não informado'
                                                | cpf
                                            }}
                                        </p>
                                    </div>
                                </div>
                            </li>
                            <li class="collection-item">
                                <div>Data nascimento
                                    <div class="secondary-content card-subtitle">
                                         <p>
                                            {{ pedido.cliente_has_produto.cliente.pessoa.pessoa_data_nascimento | moment("DD/MM/YYYY") }}
                                        </p>
                                    </div>
                                </div>
                            </li>
                            <li class="info-big collection collection-item">
                                <span>End. Residencial</span>
                                    <p v-if="pedido.cliente_has_produto.cliente.pessoa.endereco">
                                            {{ pedido.cliente_has_produto.cliente.pessoa.endereco.endereco_logradouro}}
                                            {{ pedido.cliente_has_produto.cliente.pessoa.endereco.endereco_numero}},
                                            {{ pedido.cliente_has_produto.cliente.pessoa.endereco.endereco_complemento}}

                                            {{ pedido.cliente_has_produto.cliente.pessoa.endereco.endereco_bairro}},
                                            {{ pedido.cliente_has_produto.cliente.pessoa.endereco.endereco_cidade}} - {{ pedido.cliente_has_produto.cliente.pessoa.endereco.endereco_estado}}

                                            - CEP: {{ pedido.cliente_has_produto.cliente.pessoa.endereco.endereco_cep}}

                                    </p>
                                    <p class="secondary-content card-subtitle" v-else>
                                        Não informado
                                    </p>
                            </li>
                            <li class="info-big collection collection-item">
                                <span>Observações</span>
                                        <p>{{ pedido.cliente_has_produto.cliente.pessoa.pessoa_observacao }}</p>
                            </li>
                             <li class="info-big collection collection-item data-criacao">
                                <div>Data de criação do Lead
                                    <div class="secondary-content card-subtitle">
                                         <p>{{ this.getData(pedido.cliente_has_produto.cliente.data_criacao) }} - {{ this.getHora(pedido.cliente_has_produto.cliente.data_criacao) }}h</p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>

                </div>

            </div>

        </div>
    </div>
        <div class="card">
            <div id="card-content" class="card-content">
                <div class="row">
                    <div class="col m12 s12 l12">
                        <h4 class="title header2">Produtos</h4>
                    </div>
                </div>
                <div v-if="pedido.cliente_has_produto.produto.produto_nome === 'Nenhum'">
                    <div class="secondary-content card-subtitle">
                        <a
                            style="text-transform: capitalize !important;"
                            v-if="checaUsuario()"
                            @click="abreModalAdicionarProduto()">
                            Adicionar Produto
                        </a>
                        <button id="autorenew"
                            v-if="checaUsuario()"
                            @click="abreModalAdicionarProduto()"
                            class="waves-effect waves-teal btn-flat no-padding"
                            v-tooltip.bottom="'Adicionar produto'">
                            <i class="material-icons">add_shopping_cart</i>
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col m3 s3 l3">
                        <i class="material-icons left" :class="checkStatusIcone()" v-tooltip="pedido.cliente_has_produto.produto.produto_nome">
                            {{ pedido.cliente_has_produto.produto.produto_icone }}
                        </i>
                    </div>
                    <div  class="col m10 s10 l10" v-if="pedido.comentario_carro" v-html="pedido.comentario_carro.pedido_historico_comentario">
                    </div>
                </div>
            </div>
        </div>


        <!-- Modal troca responsavel -->
        <div id="modalTroca" class="modal modal-fixed-footer">
            <div class="modal-content pt-0 pl-0 pr-0">
                <div class="modal-header">
                    <div class="row pt-2">
                        <div class="col m12">
                            <h4 class="ml-2 header2">Trocar responsável</h4>
                        </div>
                    </div>
                </div>
                <div class="col m6">
                    <label for="pedido_troca_responsavel">Responsável</label>
                    <select class="browser-default" v-model="trocaResponsavel.funcionario_id" id="pedido_troca_responsavel">
                        <option value="" disabled selected>Selecione um responsavel</option>
                        <option v-for="responsavel in funcionarios" :value="responsavel.funcionario_id">{{ responsavel.pessoa.pessoa_nome }}</option>
                    </select>
                </div>
            </div>
            <div class="modal-footer grey lighten-3">
                <button class="modal-action modal-close btn waves-effect waves-light grey darken-1">Cancelar</button>
                <button @click="trocarResponsavel()" class="btn waves-effect waves-light">Trocar</button>
            </div>
        </div>
        <!-- Modal adicionar produto -->
        <div id="modalAdicionarProduto" class="modal modal-fixed-footer">
            <div class="modal-content pt-0 pl-0 pr-0">
                <div class="modal-header">
                    <div class="row pt-2">
                        <div class="col m12">
                            <h4 class="ml-2 header2">Adicionar Produto</h4>
                        </div>
                    </div>
                </div>
                <div class="col m6">
                    <label for="pedido_adiciona_produto">Produto</label>
                    <select class="browser-default" v-model="adicionaProduto.produto_id" id="pedido_adiciona_produto">
                        <option value="" disabled selected>Selecione um produto</option>
                        <option v-for="produto in produtos" :value="produto.produto_id">{{ produto.produto_nome }}</option>
                    </select>
                </div>
            </div>
            <div class="modal-footer grey lighten-3">
                <button class="modal-action modal-close btn waves-effect waves-light grey darken-1">Cancelar</button>
                <button @click="adicionarProduto()" class="btn waves-effect waves-light">Adicionar</button>
            </div>
        </div>
    </div>
</template>
<style>
    #pedido_troca_responsavel option{
        text-transform: uppercase !important;
    }
    .icon-action{
        position: absolute;
        top: 0;
        right: 0;
    }
    .card-user{
        position: relative;
    }
    .card.card-profile {
        margin-top: 0;
    }
    .card-personal{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        flex-direction: column;
    }
    .card-personal .card-title{
        margin-top: 20px;
        margin-bottom: 10px;
    }
    .card-personal .card-actions{
        margin-top: 20px;
        display: flex;
        flex-direction: column;
    }
    .card-personal .card-actions .btn{
        padding: 0 1rem;
        margin: .2rem;
    }

    .collection{
        margin-top:30px;
    }

    .card-personal .collection-item{
        padding-left: 0;
        padding-right: 0;
        word-wrap: break-word;
        word-break: break-all;
    }
    .card-personal .card-subtitle{
        color: #b5b5b5;
        text-align: right;
    }
    .card-personal .collection{
        border-top: 0;
        border-bottom: 0;
        border-left: 0;
        border-right: 0;
    }
    .card-personal .collection-item-custom{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        background-color: #fff;
        line-height: 1.5rem;
        padding: 10px 0;
        margin: 0;
        border-bottom: 1px solid #e0e0e0;
        align-content: center;
    }
     .data-criacao{
         border: none !important;
     }


    .card-personal .collection-item-custom span{
        width: 47px;
    }
    .card-personal .collection-item-custom p{
        color: #b6b6b6;
        width: calc(100% - 95px);
        margin-left: 48px;
        text-align: right;
        height: auto;
        word-wrap: break-word;
    }
    .card-personal .collection-item-custom-big span{
        width: 110px;
    }
    .card-personal .collection-item-custom-big p{
        width: calc(100% - 165px);
        margin-left: 50px;
    }
    #InformacoesAdicionais #profile-card .card-profile-image {
        width: 70px;
        height: 70px;
        position: absolute;
        top: 10px;
        z-index: 1;
        cursor: pointer;
        right: 10px;

    }

    .card-profile-image-action{
        opacity: 0;
        position: absolute;
        height: 150px;
        width: 150px;
        border-radius: 50%;
        background-color: #1eb6dc;
        display:flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        cursor: pointer;

    }
    .card-profile-image-action:hover{
        opacity: .7;
    }

    #InformacoesAdicionais .card-profile-image {
        cursor: pointer;
    }

    .collection-item.avatar img {
        border-radius: 50%;
        position: absolute;
        width: 42px;
        height: 42px;
        overflow: hidden;
        left: 15px;
    }

    .info-big p{
        color: #b5b5b5 !important;
        padding: 10px 0;
        width: 100% !important;
        border-bottom: 1px solid #e0e0e0 !important;
    }
    .info-big.data-criacao p{
        border-bottom: none !important;
    }
</style>
<script>
    import { get, post, getUrl, api, put } from '@/helpers/api';
    import Message from '@/helpers/message';
    import Anexo from '@/components/lead/Anexo'
    import { DONO, GERENTE, CORRETOR, ESPECIALISTA, LIDER, MASTER } from '@/constants/funcionarioCargo.js';
    import Auth from '@/store/auth';
    import myUpload from 'vue-image-crop-upload';
    import { checaCargo as myChecaCargo} from '@/helpers/perfil';

    import {
            ESTAGIO_EFETIVADO,
            ESTAGIO_NEGATIVADO,
        } from '@/constants/pedidoEstagio.js';
    export default {
        components: {
            myUpload,
            Anexo
        },
        props: ['pedido', 'modalCold', 'modalLost','showButtons', 'checaCargoUsuario', 'showItem'],
        data: () => ({
            funcionarios: [],
            produtos: [],
            cargoDono: null,
            cargoGerente: null,
            cargoCorretor: null,
            cargoEspecialista: null,
            cargoLider: null,
            cargoParceiro: null,
            trocaResponsavel: {
                funcionario_id: ''
            },
            adicionaProduto: {
                produto_id: ''
            },
            usuarioLogadoCargo: null,

            imgDataUrl: '',
            params: {
                name: 'avatar'
            },
            show: false,
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${Auth.state.api_token}`
            },
            url: '',

        }),
        created() {
            let self = this;
            this.cargoDono = DONO;
            this.cargoGerente = GERENTE;
            this.cargoCorretor = CORRETOR;
            this.cargoEspecialista = ESPECIALISTA;
            this.cargoLider = LIDER;

            if (Auth.state.user.pessoa.funcionario.funcionario_cargo_id !== 3)
            {
                api.get('funcionario').then(function (response) {
                    self.funcionarios = response.data.result.data;

                    const screenSize = $(window).width();
                    if (screenSize <= 320){
                    //    self.pedido.pedido_historico.funcionario.pessoa.pessoa_nome =  self.pedido.pedido_historico.funcionario.pessoa.pessoa_nome.substr(0, 19);
                    }
                });
                api.get('produto').then(function (response) {
                    self.produtos = response.data.result.data;
                });
            }

            this.usuarioLogadoCargo = Auth.getCargoUsuario();
        },
        mounted() {
            $('#modalTroca').modal();
            $('#modalAdicionarProduto').modal();
            //this.imgDataUrl = this.pedido.cliente_has_produto.cliente.pessoa.pessoa_avatar;
            // console.log(this.pedido.cliente_has_produto.cliente, '9');
        },
        methods: {
            capitalize(value){
                return value.toLowerCase();
            },
            myChecaCargoUsuario(cargoMono, cargoMulti){
              return myChecaCargo(cargoMono, cargoMulti)
            },
            disableField(){
                return this.pedido.pedido_historico.pedido_estagio_id  == ESTAGIO_NEGATIVADO || this.pedido.pedido_historico.pedido_estagio_id  == ESTAGIO_EFETIVADO ? 'disabled' : '';
            },
            checarVizualisacao() {
                if (typeof this.pedido.cliente_has_produto !== 'undefined') {
                    this.imgDataUrl = this.pedido.cliente_has_produto.cliente.pessoa.pessoa_avatar;
                    return true;
                }
                return false;
            },
            checkStatusIcone(){
                if(this.pedido.pedido_historico.pedido_estagio_id  == ESTAGIO_NEGATIVADO){
                    return 'red-text';
                }
                else if(this.pedido.pedido_historico.pedido_estagio_id  == ESTAGIO_EFETIVADO){
                    return 'green-text';
                }
                else{
                    return '';
                }
            },
            abreModalTroca() {
                setTimeout(function () {
                    $('#modalTroca').modal();
                    $('#modalTroca').modal('open');
                }, 500);
            },
            abreModalAdicionarProduto() {
                setTimeout(function () {
                    $('#modalAdicionarProduto').modal();
                    $('#modalAdicionarProduto').modal('open');
                }, 500);
            },
            trocarResponsavel() {
                if (this.trocaResponsavel.funcionario_id === '') {
                    Message.messageError('Selecione o responsável.');
                    return false;
                }

                let self = this;
                post('pedido-historico/troca-responsavel', {
                    pedido_historico_id: this.pedido.pedido_historico_id,
                    funcionario_id: this.trocaResponsavel.funcionario_id
                }).then(function (response) {
                    self.$emit('atualiza', [
                        response.data.result.data
                    ]);
                    self.trocaResponsavel = {
                        funcionario_id: ''
                    };
                    Message.messageSuccess('Responsável trocado com sucesso.');
                    $('#modalTroca').modal('close');
                }).catch(function () {
                    Message.messageError('Erro ao trocar responsável.');
                    $('#modalTroca').modal('close');
                });
            },
            adicionarProduto() {
                if (this.adicionaProduto.produto_id === '') {
                    Message.messageError('Selecione um produto.');
                    return false;
                }

                let self = this;
                put(`/pedido/update-produto/${this.pedido.pedido_id}`, {
                    produto_id: this.adicionaProduto.produto_id,
                }).then(function (response) {
                    self.$emit('atualiza', [
                        response.data.result.data
                    ]);
                    self.adicionaProduto = {
                        produto_id: ''
                    };
                    Message.messageSuccess('Produto adicionado com sucesso.');
                    $('#modalAdicionarProduto').modal('close');
                    self.$router.go(0)
                }).catch(function () {
                    Message.messageError('Erro ao trocar o produto.');
                    $('#modalAdicionarProduto').modal('close');
                });
            },
            checaUsuario() {
                if (this.usuarioLogadoCargo === MASTER) {
                    return true;
                } else if ([DONO, GERENTE, ESPECIALISTA].indexOf(this.usuarioLogadoCargo) !== -1) {
                    return true;
                } else {
                    return false;
                }
            },
            clienteEditar(id) {
                this.$router.push('/cliente/'+id)
            },
            cropSuccess(imgDataUrl, field){
                // console.log('-------- crop success --------');
            },
            cropUploadSuccess(jsonData, field){
                this.imgDataUrl = jsonData.result.data;
                this.avatar = jsonData.result.data;
                this.show = false;
                location.reload();
            },
            cropUploadFail(status, field){
                this.show = false;
            },
            showModalAvatar() {
                this.show = true;
                this.url = getUrl('cliente/upload-imagem/?cliente_id='+this.pedido.cliente_has_produto.cliente.cliente_id);
            },
            getData(data) {
                return moment(data).format('DD/MM/YYYY');
            },
            getHora(data) {
                return moment(data).format('HH:mm');
            }
        },

        filters: {
             moment: (value, format) => {

                const date = moment(value);

                return value && date.isValid() ? date.format(format) : 'Não informado';
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/lead/InformacoesAdicionais.vue